
import React, { useEffect, useMemo } from "react";
import CartItem from "./CartItem";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCart } from "../../../Redux/Customers/Cart/Action";



const Cart = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const jwt = localStorage.getItem("jwt");

  const { cart } = useSelector((store) => store);

  useEffect(() => {
    if (jwt) {
      dispatch(getCart(jwt));
    }
  }, [dispatch, jwt, cart.cartItems.length]);

  // Calculate price details dynamically
  const { totalItem, totalPrice, totalDiscountedPrice, totalDiscount } = useMemo(() => {
    let totalItem = 0;
    let totalPrice = 0;
    let totalDiscountedPrice = 0;
    
    cart.cartItems.forEach((item) => {
      totalItem += item.quantity;
      totalPrice += item.product.price * item.quantity;
      totalDiscountedPrice += item.product.discountedPrice * item.quantity;
    });

    const totalDiscount = totalPrice - totalDiscountedPrice;

    return { totalItem, totalPrice, totalDiscountedPrice, totalDiscount };
  }, [cart.cartItems]);

  return (
    <div className="">
      {cart.cartItems.length > 0 && (
        <div className="lg:grid grid-cols-3 lg:px-16 relative">
          {/* Cart Items Section */}
          <div className="lg:col-span-2 lg:px-5 bg-white">
            <div className="space-y-3">
              {cart.cartItems.map((item) => (
                <CartItem key={item._id} item={item} showButton={true} />
              ))}
            </div>
          </div>
          
          {/* Price Details Section */}
          <div className="px-5 sticky top-0 h-[100vh] mt-5 lg:mt-0 ">
            <div className="border p-5 bg-white shadow-lg rounded-md">
              <p className="font-bold opacity-60 pb-4">PRICE DETAILS</p>
              <hr />
              <div className="space-y-3 font-semibold">
                <div className="flex justify-between pt-3 text-black">
                  <span>Price ({totalItem} item)</span>
                  <span>₹{totalPrice}</span>
                </div>
                <div className="flex justify-between">
                  <span>Discount</span>
                  <span className="text-green-700">-₹{totalDiscount}</span>
                </div>
                <div className="flex justify-between">
                  <span>Delivery Charges</span>
                  <span className="text-green-700">Free</span>
                </div>
                <hr />
                <div className="flex justify-between font-bold text-lg">
                  <span>Total Amount</span>
                  <span className="text-green-700">₹{totalDiscountedPrice}</span>
                </div>
              </div>
              <Button
                onClick={() => navigate("/checkout?step=2")}
                variant="contained"
                type="submit"
                sx={{
                  padding: ".8rem 2rem",
                  marginTop: "2rem",
                  width: "100%",
                  backgroundColor: "#854d0e",
                  '&:hover': {
                    backgroundColor: "#a16212", 
                  },
                }}
              >
                Check Out
              </Button>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Cart;
